const formData = {
    formId: "trainingOrderForm",
    formField: {
        createdDate: {
            name: "createdDate",
            label: "Created Date",
        },
        dueDate: {
            name: "dueDate",
            label: "Training Needed Date",
            requiredErrorMessage: "Date is required.",
        },
        startDate: {
            name: "startDate",
            label: "Start Date",
        },
        endDate: {
            name: "endDate",
            label: "End Date",
        },
        vessel: {
            name: "vessel",
            label: "Vessel",
            requiredErrorMessage: "Vessel is required.",
        },
        assignee: {
            name: "assignee",
            label: "Assignee",
            requiredErrorMessage: "Assignee is required.",
        },
        mariner: {
            name: "mariner",
            label: "Mariner",
            requiredErrorMessage: "Mariner is required.",
        },
        marinerLeavingFrom: {
            name: "marinerLeavingFrom",
            label: "Leaving From",
            requiredErrorMessage: "Mariner Leaving From is required.",
        },
        marinerDestination: {
            name: "marinerDestination",
            label: "Destination",
            requiredErrorMessage: "Mariner destination is required.",
        },
        marinerTravelTimestamp: {
            name: "marinerTravelTimestamp",
            label: "Time",
            requiredErrorMessage: "Mariner travel time is required.",
        },
        marinerAccomodation: {
            name: "marinerAccomodation",
            label: "Hotel or Rental",
            requiredErrorMessage: "Mariner Accomodation is required.",
        },
        marinerPickupDate: {
            name: "marinerPickupDate",
            label: "Check In / Pick Up Date",
            requiredErrorMessage: "Mariner Check In / Pick Up Date is required.",
        },
        marinerDropoffDate: {
            name: "marinerDropoffDate",
            label: "Check Out / Drop Off Date",
            requiredErrorMessage: "Mariner Check Out / Drop Off Date is required.",
        },
        comments: {
            name: "comments",
            label: "Mariner Comments",
        },
        marinerTwicTsaNum: {
            name: "marinerTwicTsaNum",
            label: "TWIC or TSA #",
        },
        marinerDateOfBirth: {
            name: "marinerDateOfBirth",
            label: "DOB",
        },
        checklistRoot: {
            name: "checklistRoot",
            label: "",
        },
        travelDocuments: {
            name: "travelDocuments",
            label: "Travel Documents",
        },
        rating: {
            name: "rating",
            label: "Rating",
            requiredErrorMessage: "Rating is required.",
        },
        flightNotice: {
            name: "flightNotice",
            label: "Fly 24hr Prior (Y/N)",
        },
        trainingLocation: {
            name: "trainingLocation",
            label: "Course Location",
            requiredErrorMessage: "Course Location is required.",
        },
        training: {
            name: "training",
            label: "Training Course Name",
            requiredErrorMessage: "Course Name is required."
        },
        daysToBePaid: {
            name: "daysToBePaid",
            label: "Days to be Paid",
        },
        note: {
            name: "note",
            label: "Training Order Notes",
        },
    }
};

export default formData;